<div class="payment-container mat-elevation-z2 p-4">
  <h1 style="font-weight: 600;">Zahlungsmethoden</h1>


  <button *ngIf="this.isUserAdminOfOrganisationOrPlattformAdmin()" matButton="elevated" color="primary"
    (click)="addPaymentMethod()">
    Neue Zahlungsmethode hinzufügen
  </button>

  <div class="payment-list">
    <div *ngFor="let data of paymentDatas" class="payment-method-item">
      <div *ngIf="data.type === 'card'" class="center-elements">
        <div class="creditCardContainer">
          <!--           <div class="credit-card-info" [class]="{
                                                    'visa-card': data.card.display_brand === 'visa',
                                                    'master-card': data.card.display_brand === 'mastercard',
                                                    'american-express-card': data.card.display_brand === 'american_express',
                                                    'other-card': !['visa', 'mastercard', 'american_express'].includes(data.card.display_brand)
                                                  }">
                      <div class="card-holder">{{ data.cardHolder }}</div>
                      <div class="card-number">**** **** **** {{ data.card.last4 }}</div>
                      <div class="expiration">Expires: {{ data.card.exp_month }}/{{ data.card.exp_year }}</div>
                      <div class="card-type">{{ data.card.display_brand | uppercase }}</div>
                      </div> -->
          <app-swarm-credit-card [cardNumber]="'**** **** **** '+data.card.last4" [name]="data.cardHolder"
            [expirationDate]="data.card.exp_month+'/'+data.card.exp_year" [bankName]="data.card.brand"
            [securityCode]="'****'" [IBAN]="'**** **** **** '+data.card.last4"
            [IBAN_Text]="data.card.brand + ' card IBAN'"></app-swarm-credit-card>
          <div class="payment-buttons">
            <red-trash-can-button [class]="'btn-shadow'" (click)="deletePaymentMethod(data.id)"
              *ngIf="this.isUserAdminOfOrganisationOrPlattformAdmin()"></red-trash-can-button>
          </div>
        </div>
        <div *ngIf="data.showPossibleReplacement && this.isUserAdminOfOrganisationOrPlattformAdmin()"><button
            (click)="replacePaymentMethod(data.id)" class="alternative-btn">Als Alternative festlegen</button></div>
      </div>
      <div *ngIf="data.type === 'link'" class="center-elements">
        <div class="creditCardContainer">
          <app-swarm-credit-card [cardNumber]="''" [name]="data.cardHolder" [expirationDate]="''" [bankName]="data.type"
            [securityCode]="'****'" [IBAN]="''" [IBAN_Text]="data.type + ' card'"></app-swarm-credit-card>
          <div class="payment-buttons">
            <red-trash-can-button [class]="'btn-shadow'" (click)="deletePaymentMethod(data.id)"
              *ngIf="this.isUserAdminOfOrganisationOrPlattformAdmin()"></red-trash-can-button>
          </div>
        </div>
        <div *ngIf="data.showPossibleReplacement && this.isUserAdminOfOrganisationOrPlattformAdmin()"><button
            (click)="replacePaymentMethod(data.id)" class="alternative-btn">Als Alternative festlegen</button></div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="loading" class="loading-overlay-spinner">
  <mat-spinner></mat-spinner>
</div>